import React from 'react';

import PickupOrderListItem from '../../../models/PickupOrderListItem';

import style from './ordersDriver.module.css';
import commonStyles from '../../common/common.module.css';

import MaterialTable from 'material-table';

import { Paper } from '@material-ui/core'; 

interface DriverAWBTableMobileProps {
  orderListItems: Array<PickupOrderListItem>;
};

const driverAWBTableMobile = (props: DriverAWBTableMobileProps) => {

  const { orderListItems } = props;

  return (
    <div className={ style.tableWrapper }>
     
      <MaterialTable

        components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}
        
        data = { orderListItems }

        columns = {[
          { title: 'Airwaybill', field: '', 
            cellStyle: { color: 'var(--primaryblue)', fontSize: '14px' , paddingLeft: '5px', paddingRight: 0,width: '106px',paddingTop: '10px' },
            headerStyle: { paddingLeft: '5px', paddingRight: 0}, 
            render: (rowData: PickupOrderListItem) => {
   
              const returned = rowData.returned ? 'Return to Driver' : '';

              return (
                <div>
                  <div>{ rowData.code }-{ rowData.number }</div>
                  <span style={{ color: 'red' }}>{ returned }</span>
                </div>
              )
            }
          },
          { title: 'Pcs', field: '', 
            cellStyle: { color: 'var(--primaryblue)' , fontSize: '14px', paddingLeft: '5px' ,paddingRight: '5px' ,paddingTop: '10px'}, 
            headerStyle: { paddingLeft: '5px', paddingRight: '5px', }, 
            render: (rowData: PickupOrderListItem) => {

              return  <div>{ rowData.pieces }</div>
            },       
          },
          { title: 'Wgt', field: '', 
            cellStyle: { color: 'var(--primaryblue)', fontSize: '14px' , paddingLeft: '5px', paddingRight: 0 , paddingTop: '10px'}, 
            headerStyle: { paddingLeft: '5px', paddingRight: 0 }, 
            render: (rowData: PickupOrderListItem) => {

              return  <div>{ rowData.weight }K</div>
            }, 
          },
          { title: 'Remarks', field: '', 
            cellStyle: { color: 'var(--primaryblue)', fontSize: '14px' , paddingLeft: '10px', paddingRight: '5px', paddingTop: '10px'}, 
            headerStyle: { paddingLeft: '10px', paddingRight: '5px'}, 
            render: (rowData: PickupOrderListItem) => {

              return <span>{ rowData.remarks_text }</span>
            }, 
          }
        ]}

        options = {{
          search: false,
          paging: false,
          showTitle: false,
          actionsColumnIndex: -1,
          toolbar: false,
          sorting: false,
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
          },
          rowStyle: {
            verticalAlign: 'top'
          }           
        }}
      />
    </div>
  );
}

export default driverAWBTableMobile;